import {
  type AnalyticsDataSource,
  type DashboardModelSavedReportsModel,
  type FilterMode,
  type Metric,
  type Positions,
  type ReportOrgMetadataModel,
} from "@doitintl/cmp-models";
import { type ModelReference, type ModelTimestamp, type WithModel } from "@doitintl/models-any";
import { type DateTime } from "luxon";

import { type WithRequiredProperty } from "../utils/WithRequiredProperty";

export type ReportWSnap = {
  data: WithModel<WithRequiredProperty<DashboardModelSavedReportsModel, "customer">> & { owner: string };
  ref: ModelReference<DashboardModelSavedReportsModel>;
};

export type CustomTimeRange = {
  to: ModelTimestamp | DateTime;
  from: ModelTimestamp | DateTime;
};

export type ReportCustomTimeRange = {
  to: DateTime;
  from: DateTime;
} | null;

export type MetadataOptionData = Omit<WithModel<ReportOrgMetadataModel>, "organization"> & {
  organization: WithModel<ReportOrgMetadataModel>["organization"] | null;
};

export type MetadataOptionFilter = {
  mode: FilterMode;
  _filter: string[] | null;
  _regexp: string | null;
  _inverse: boolean;
  _limit: number | null;
  _limitOrder: string | null;
  _limitMetric: Metric | null;
};

export type MetadataOption = MetadataOptionFilter & {
  id: string;
  mode?: FilterMode;
  _disabled: boolean;
  _isDragging: boolean;
  _position: Positions;
  _values: {
    awsValues: string[];
    gcpValues: string[];
    azureValues: string[];
    datahub: string[];
    snowflake: string[];
    datadog: string[];
    openai: string[];
    cloudzero: string[];
  };
  _visible: boolean;
  _available?: boolean;
  _metricFilter?: boolean;
  typeLabel?: string;
  dataSource?: AnalyticsDataSource;
  data: MetadataOptionData;
  selectedValue?: string;
};

export type AttributionMetadataOption = Pick<
  MetadataOption,
  "id" | "typeLabel" | "data" | "_filter" | "_values" | "_visible" | "_disabled"
>;

export enum TemplateVisibilityRoles {
  PRIVATE = "Private",
  DOIT = "DoiT",
  PUBLIC = "Public",
}
